/**
 * @generated SignedSource<<ef3fc4f0e3c14d0cb8c29aeb05c98e08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberSelectEventFragment$data = {
  readonly textareaMembers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entity: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"MemberSelectEntityFragment">;
        };
      };
    }>;
  };
  readonly " $fragmentType": "MemberSelectEventFragment";
};
export type MemberSelectEventFragment$key = {
  readonly " $data"?: MemberSelectEventFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberSelectEventFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberSelectEventFragment",
  "selections": [
    {
      "alias": "textareaMembers",
      "args": null,
      "concreteType": "EventMembershipConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventMembershipEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "entity",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "MemberSelectEntityFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "95a86af6164bb62782f7be9495e5b75d";

export default node;
